import '@fontsource/poppins/index.css';

export const fonts = {
    heading: "'Poppins', sans-serif",
    body: "'Poppins', sans-serif"
};
